import React from 'react';
import { Box } from '@chakra-ui/react';
import useResponsive from 'hooks/useResponsive';
import Heading from './Heading';

const HeroImage = () => {
  const { isMobile } = useResponsive();

  return (
    <Box data-testid="heroImage" width={isMobile ? '100%' : '55%'} flex={isMobile ? '0 0 100%' : '0 0 55%'} maxWidth={'100%'} minHeight={isMobile ? "unset" : "100vh"} maxHeight={isMobile ? "360px" : "unset"} height={isMobile ? "50vh" : "auto"} background={"linear-gradient(332deg, #D72E2A 1.61%, #E05030 98.95%)"} backgroundSize="contain">
      <Box data-testid="heroImage_graphic" width={'100%'} flex={isMobile ? '0 0 100%' : '0 0 55%'} maxWidth={'100%'} minHeight={isMobile ? "unset" : "100vh"} maxHeight={isMobile ? "360px" : "unset"} height={isMobile ? "50vh" : "auto"} background={isMobile ? "url('/assets/images/hero-image-graphic-mobile.png')" : "url('/assets/images/hero-image-graphic.png')"} backgroundRepeat="no-repeat" backgroundSize="contain" sx={{
        backgroundPositionX: "right",
        backgroundPositionY: isMobile ? "calc(100% - 20px)" : "bottom"
      }}>
        <Heading />
      </Box>
    </Box>
  );
}

export default HeroImage;
